import { createSelector } from 'reselect';

export const authSelectors = {
    getUser: createSelector(
        (state) => state.auth.user,
        (user) => user
    ),
};
